'use client';

import { observer } from 'mobx-react-lite';

import { ScenarioCredentialsSection } from './components/ScenarioCredentialsSection';

import { appPreferencesStore } from '@/app/global/appPreferencesStore';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

/**
 * Application-level settings shared by the Editor and Dashboard.
 * Houses global preferences such as third-party API credentials.
 */
export const AppSettingsDialog = observer(() => {
  const open = appPreferencesStore.appSettingsDialogOpen;

  const handleOpenChange = (next: boolean) => {
    if (!next) {
      appPreferencesStore.closeAppSettings();
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="flex h-[min(80vh,45rem)] flex-col overflow-hidden sm:max-w-2xl">
        <DialogHeader className="shrink-0">
          <DialogTitle>Application Settings</DialogTitle>
          <DialogDescription>
            Preferences and credentials that apply across the entire application.
          </DialogDescription>
        </DialogHeader>

        <div className="min-h-0 flex-1 overflow-x-hidden overflow-y-auto py-4 text-sm">
          <ScenarioCredentialsSection active={open} />
        </div>

        <DialogFooter className="shrink-0">
          <Button type="button" variant="outline" onClick={() => handleOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});

AppSettingsDialog.displayName = 'AppSettingsDialog';
